export class ExamsDataItem {
  id: number = null;
  enrollId: number = null;
  subjectId: number = null;
  name: string = '';
  balls: any[] = [];
  points: number = null;
  admissionDate: Date = new Date();
  admissionTime: string = "00:00";
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/dialogs/common-dialog/model/ExamsDataItem.ts